<div
  id="kt_app_header"
  class="app-header"
  data-kt-sticky="true"
  data-kt-sticky-activate="{default: true, lg: true}"
  data-kt-sticky-name="app-header-minimize"
  data-kt-sticky-offset="{default: '200px', lg: '0'}"
  data-kt-sticky-animation="false"
>
  <div
    class="app-container container-fluid d-flex align-items-stretch justify-content-between"
    id="kt_app_header_container"
  >
    <div
      class="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2"
      title="Show sidebar menu"
    >
      <div
        class="btn btn-icon btn-active-color-primary w-35px h-35px"
        id="kt_app_sidebar_mobile_toggle"
      >
        <i class="ki-duotone ki-abstract-14 fs-2 fs-md-1">
          <span class="path1"></span>
          <span class="path2"></span>
        </i>
      </div>
    </div>
    <div
      class="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
      id="kt_app_header_wrapper"
    >
      <div
        class="app-header-menu app-header-mobile-drawer align-items-stretch"
        data-kt-drawer="true"
        data-kt-drawer-name="app-header-menu"
        data-kt-drawer-activate="{default: true, lg: false}"
        data-kt-drawer-overlay="true"
        data-kt-drawer-width="250px"
        data-kt-drawer-direction="end"
        data-kt-drawer-toggle="#kt_app_header_menu_toggle"
        data-kt-swapper="true"
        data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
        data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
      >
        <div
          class="menu menu-rounded menu-column menu-lg-row my-5 my-lg-0 align-items-stretch fw-semibold px-2 px-lg-0"
          id="kt_app_header_menu"
          data-kt-menu="true"
        >
          <!-- <h3 class="align-items-start flex-column my-10">
            <span class="card-label fw-bold fs-3 mb-1"
              >Hello, {{ currentUser?.role }}!</span
            >
          </h3> -->
        </div>
      </div>
      <div class="app-navbar flex-shrink-0">
        <!-- Notifications -->
        <!-- <div class="app-navbar-item ms-1 ms-md-4">
          <div
            class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px cursor-pointer"
            data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
            id="kt_menu_item_wow"
            title="Notifications"
          >
            <i class="fa-regular fa-bell">
              <div
                *ngIf="unReadNotificationMessageCount"
                class="unread-notification-count"
              >
                {{ unReadNotificationMessageCount }}
              </div>
            </i>
          </div>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px"
            data-kt-menu="true"
            id="kt_menu_notifications"
          >
            <div
              class="d-flex flex-column bgi-no-repeat rounded-top"
              style="background-color: #0f123f"
            >
              <h3 class="text-white fw-semibold px-9 mt-10 mb-6">
                Notifications
              </h3>
            </div>
            <div class="tab-content">
              <div
                class="tab-pane fade show active"
                id="alerts"
                role="tabpanel"
              >
                <div class="scroll-y mh-325px">
                  <div *ngIf="notificationList?.length; else noNotification">
                    <div
                      class="read-or-delete pt-4 ps-8 d-flex align-items-center fs-5 gap-6"
                    >
                      <p>
                        <a (click)="readAllNotification()" class="link-dark"
                          >Read All</a
                        >
                      </p>
                      <p>
                        <a (click)="deleteAllNotification()" class="link-danger"
                          >Delete All</a
                        >
                      </p>
                    </div>
                    <div
                      *ngFor="
                        let notification of notificationList;
                        let i = index
                      "
                      class="d-flex align-items-center justify-content-between py-4 ps-8"
                      [ngClass]="{
                        'bg-secondary': !notification.isRead,
                        'bg-white': notification.isRead
                      }"
                      [ngStyle]="{
                        'border-bottom':
                          i < notificationList.length - 1
                            ? '2px solid #dbe2e9'
                            : ''
                      }"
                    >
                      <div class="mb-0 me-2">
                        <div class="fs-7 mb-1">
                          {{ notification?.message }}
                        </div>
                        <div class="fs-7 mb-1">
                          Created Date:
                          <strong>
                            {{
                              notification?.createdDate
                                ? (notification?.createdDate
                                  | date : "dd-MM-yyyy hh:mm")
                                : "-"
                            }}
                          </strong>
                        </div>
                      </div>
                      <div
                        class="notification-action-btns d-flex align-items-center"
                      >
                        <a
                          *ngIf="!notification?.isRead"
                          (click)="checkNotification(notification?.id || '')"
                          class="btn btn-icon btn-active-color-primary btn-sm cursor-pointer"
                          ><i class="fa-solid fa-check"></i></a
                        ><a
                          (click)="deleteNotification(notification?.id || '')"
                          class="btn btn-icon btn-active-color-primary btn-sm cursor-pointer"
                          ><i class="fa-regular fa-trash-can"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                  <ng-template #noNotification>
                    <div class="py-4 px-8">
                      <p class="fs-5">No notification to be displayed.</p>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- Theme Selection -->
        <div class="app-navbar-item ms-1 ms-md-4">
          <a
            class="btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px"
            data-kt-menu-trigger="hover"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
            title="Theme Selection"
          >
            <i class="fa-regular fa-sun theme-light-show"></i>
            <i class="fa-solid fa-moon theme-dark-show"></i>
          </a>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-gray-500 menu-active-bg menu-state-color fw-semibold py-4 fs-base w-150px"
            data-kt-menu="true"
            data-kt-element="theme-mode-menu"
          >
            <div class="menu-item px-3 my-0">
              <a
                class="menu-link px-3 py-2 cursor-pointer"
                (click)="setTheme('light')"
              >
                <span class="menu-icon" data-kt-element="icon">
                  <i class="fa-regular fa-sun ki-night-day"></i>
                </span>
                <span class="menu-title">{{ "lightTheme" | translate }}</span>
              </a>
            </div>
            <div class="menu-item px-3 my-0">
              <a
                class="menu-link px-3 py-2 cursor-pointer"
                (click)="setTheme('dark')"
              >
                <span class="menu-icon" data-kt-element="icon">
                  <i class="fa-solid fa-moon"></i>
                </span>
                <span class="menu-title">{{ "darkTheme" | translate }}</span>
              </a>
            </div>
          </div>
        </div>
        <!-- User Menu -->
        <div
          class="app-navbar-item ms-1 ms-md-4"
          id="kt_header_user_menu_toggle"
        >
          <div
            class="d-flex align-items-center cursor-pointer symbol symbol-35px"
            data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
          >
            <img
              src="assets/media/avatars/user-profile-icon.jpg"
              class="rounded-3"
              alt="user"
            />
            <div class="me-1 d-none d-sm-block">
              <a class="text-gray-900 text-hover-primary fs-6 fw-bold p-2">{{
                currentUser?.name
              }}</a>
            </div>
            <i
              class="d-none d-sm-block fa-solid fa-angle-down text-gray-500 pt-1"
            ></i>
          </div>
          <div
            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
            data-kt-menu="true"
          >
            <div class="menu-item px-3">
              <div class="menu-content d-flex align-items-center px-3">
                <div class="symbol symbol-50px me-5">
                  <img
                    alt="Logo"
                    src="assets/media/avatars/user-profile-icon.jpg"
                  />
                </div>
                <div class="d-flex flex-column">
                  <div class="fw-bold d-flex align-items-center fs-5">
                    {{ currentUser?.name }}
                    <span
                      class="badge fw-bold fs-8 px-2 py-1 ms-2"
                      [ngClass]="statusClass"
                      >{{ statusText }}</span
                    >
                  </div>
                  <a class="fw-semibold text-muted text-hover-primary fs-7">{{
                    currentUser?.email
                  }}</a>
                  <a class="fw-semibold text-muted text-hover-primary fs-7">{{
                    currentUser?.customerCode || ""
                  }}</a>
                </div>
              </div>
            </div>
            <div class="menu-item px-5">
              <a (click)="backToMenu()" class="menu-link">
                <span class="menu-title">{{
                  "backToDermalogic" | translate
                }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
